module.exports = __webpack_public_path__ + "img/group-line.eaf068a3.svg";